import { COLOR_APP_TEXT, HEADER_FONT_FAMILY, MOBILE_SCREEN } from "../theme";
import styled from "@emotion/styled";

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${COLOR_APP_TEXT};
  font-family: ${HEADER_FONT_FAMILY};
  cursor: pointer;
  text-align: center;
  padding: 0;
  width: 24px;
  height: 24px;
  align-self: flex-end;
`;

export const DeleteButton = styled(CloseButton)`
  padding: 16px 0;
  align-self: center;
  ${MOBILE_SCREEN} {
    align-self: flex-start;
    padding: 0;
  }
`;
